import TeamPersonDelete from '@/screens/TeamPersonDelete';

export default function PrivateTeamTeamIdMemberPersonIdEditDeleteRoute() {
  return <TeamPersonDelete />;
}
